import { AlertContext } from '@/context/AlertContext';
import { useContext } from 'react';

const useAlerts = () => {
  return useContext(AlertContext);
};
export default useAlerts;
